.root input[type="search"]::-webkit-search-cancel-button,
.root input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
  appearance: none;
}